import { useTranslation } from 'react-i18next'
import { Badge } from '@/ui/components/common/Badge'
import type { Investigation } from '@/domains/types'

/**
 * Byline · date · category badges — shared across the news homepage's
 * lead story, secondary grid, category rails, and latest river.
 */
export function ArticleMeta({
  investigation,
  className,
  showCategories = true,
}: {
  investigation: Investigation
  className?: string
  showCategories?: boolean
}) {
  const { t } = useTranslation()
  const formattedDate = new Date(investigation.createdAt).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })

  return (
    <div className={`flex flex-wrap items-center gap-x-3 gap-y-1 text-xs ${className ?? ''}`}>
      {showCategories && investigation.categoryTerms && investigation.categoryTerms.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {investigation.categoryTerms.map((term) => (
            <Badge
              key={term.id}
              variant="outline"
              className="text-xs border-primary/30 text-primary"
            >
              {term.label}
            </Badge>
          ))}
        </div>
      )}
      {investigation.author && (
        <span className="text-muted-foreground">
          {t('investigation_detail.by')}{' '}
          <span className="text-foreground/70">{investigation.author}</span>
        </span>
      )}
      <span className="text-muted-foreground">{formattedDate}</span>
    </div>
  )
}
